import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(
  {
    root: {
      backgroundColor: 'transparent',
    },
    popover: {
      minWidth: '116.56px',
    },
  },
  { name: 'ComponentLibrary' }
);
